module.exports = __webpack_public_path__ + "static/img/little-pattern.60ef362.svg";